module.exports = __webpack_public_path__ + "static/media/logoSuperGiros.5614341d.png";